.betTypeLabel {
  display: flex;
  gap: var(--cxy-spacing-2);
  align-items: center;
  font-size: var(--cxy-fontSize-s);
}

@media (min-width: 801px) {
  .betTypeLabel {
    font-size: var(--cxy-fontSize-m);
  }
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  background-color: var(--cxy-color-container-subtle);
  cursor: pointer;
}
.icon > svg {
  transform: scale(0.7);
}
.icon.diamond {
  border: 2px solid #00dddd;
}
.icon.hot {
  border: 2px solid #ff435a;
}
